import FormModule from "components/Modules/Documents/FormModule"
import {
  createOrUpdateFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import {
  normalizeWidgetData,
  prepareWidgetDataForSave,
} from "../budgetWidgetData"

const CityBudgetEarnings = () => {
  return (
    <FormModule
      noCancel
      form={{
        title: "Earnings",
        fields: [
          {
            ID: "budget-earnings-table",
            Type: "Editable Table",
            Name: "WidgetData.data.1.data",
            Label: "Earnings",
            Columns: [
              { Name: "color", Label: "Color", Editable: true },
              { Name: "name", Label: "Name", Editable: true },
              {
                Name: "value",
                Label: "Value",
                Editable: true,
              },
            ],
            DeletedName: "DeletedEarnings",
            Creatable: true,
            Orderable: true,
          },
        ],
        getDefaultValues: async ({ firebaseUID }) => {
          const moduleDoc = await getFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/136`,
          })

          return {
            WidgetData: normalizeWidgetData(moduleDoc?.WidgetData || {}),
            DeletedEarnings: [],
          }
        },
        onSubmit: async (values, { firebaseUID }) => {
          const widgetData = prepareWidgetDataForSave(values.WidgetData || {})

          await createOrUpdateFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules`,
            values: {
              ID: "136",
              WidgetData: widgetData,
            },
          })

          return values
        },
      }}
      ID={"136"}
    />
  )
}

export default CityBudgetEarnings
